import { render } from "./PermissionsEdit.vue?vue&type=template&id=3a1e43f2"
import script from "./PermissionsEdit.vue?vue&type=script&lang=js"
export * from "./PermissionsEdit.vue?vue&type=script&lang=js"

import exportComponent from "/home/lyonjo5/lyon-marketing-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__